import React, { useContext, useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { fetchGetPromptList } from 'gqlQueries/promoRecommendation';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';

const errorMessage: string = 'Something went wrong!';

function useFetchGetPromptsList(slice = 0) {
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any | null>([]);
    const { appConfig } = useContext(UserContext);
    const promoContext = getConfig('promoRecommendation', appConfig);
    const promoTypeColorMapping: any = promoContext.promoTypeColorMapping;
    //To fetch dim
    const [fetchPromptList, { data: promptData, loading: promptLoading, error: promptError }] = useLazyQuery(
        fetchGetPromptList,
        {
            onCompleted: onFetchComplete,
            onError: onFetchError,
        },
    );

    useEffect(() => {
        setLoading(promptLoading);
    }, [promptLoading]);

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            let list = payload.getPromptsList.map((offerList: any) => {
                return {
                    ...offerList,
                    value: offerList.promptName.slice(slice),
                    label:
                        offerList.promptName in promoTypeColorMapping
                            ? promoTypeColorMapping?.[offerList.promptName]?.label
                            : offerList.promptName.replace(/_/g, ' '),
                };
            });
            setData(() => list);
        } catch (error) {
            console.error(errorMessage, error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        //sending empty data to error to avoid null data being sent
        setData([]);
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,
        data,
        fetchPromptList: (variables: any) => {
            fetchPromptList(variables);
        },
    };
}

export default useFetchGetPromptsList;
